import { render, staticRenderFns } from "./department-statistics.vue?vue&type=template&id=469fc502&scoped=true&"
import script from "./department-statistics.vue?vue&type=script&lang=js&"
export * from "./department-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469fc502",
  null
  
)

export default component.exports